(ns storrito.video
  (:require [vire.adserver.config :as cfg]
            [cljs.core.async :as async]
            [goog.object :as obj]
            ))

(defn url
  "Builds an URL to download the video for the given `blob-id`."
  [blob-id]
  (str (cfg/server) "/blob/" blob-id))

(defn metadata
  "Returns a promise-channel which will eventually contain video
   metadata as specified by `::metadata`. Closes the promise-channel,
   if the video metadata can not be extracted by the browser. Firefox
   does not support 'video/3gpp' for example."
  [blob-or-file-or-url]
  (let [chan (async/promise-chan)]
    (doto (js/document.createElement "video")
      (obj/set "preload" "metadata")
      ;; Only metadata is read here. Avoid `crossOrigin` so `/blob/...` URLs
      ;; that redirect to legacy GCS objects without CORS headers still load.
      (.addEventListener "loadedmetadata"
                         (fn [e]
                           (let [el e.currentTarget]
                             (->> {::duration el.duration
                                   ::src el.src
                                   ::width el.videoWidth
                                   ::height el.videoHeight}
                                  (async/put! chan))
                             (.remove el))))
      (.addEventListener "error"
                         (fn [_event]
                           (js/console.warn "cannot read video metadata:"
                                            blob-or-file-or-url)
                           (async/close! chan)))
      (obj/set "src" (cond
                       (string? blob-or-file-or-url) blob-or-file-or-url
                       :else (js/window.URL.createObjectURL blob-or-file-or-url))))
    chan))

(defn compatible-video?
  "Returns a promise-channel that eventually contains true when the
   browser can decode and play the video, false when playback fails or
   cannot be verified. False only means that a server-side transcode is
   requested, the server re-checks the video with ffprobe anyway."
  [blob-or-file-or-url]
  (let [chan (async/promise-chan)
        video (js/document.createElement "video")
        object-url (when-not (string? blob-or-file-or-url)
                     (js/window.URL.createObjectURL blob-or-file-or-url))
        deliver! (fn [result]
                   ;; only the first put! delivers, later calls are no-ops
                   (async/put! chan
                               result)
                   (.pause video)
                   (when object-url
                     (js/window.URL.revokeObjectURL object-url)))]
    (doto video
      ;; set the property, not only the attribute: WebKit/Chrome ignore
      ;; the muted attribute on programmatically created videos
      (obj/set "muted" true)
      (.setAttribute "muted" "")
      ;; playsinline is required for the video to not get blocked by mobile safari
      (.setAttribute "playsinline" "")
      (.addEventListener "timeupdate"
                         (fn [_event]
                           (deliver! true)))
      (.addEventListener "error"
                         (fn [_event]
                           (deliver! false)))
      (obj/set "src" (or object-url
                         blob-or-file-or-url))
      )
    ;; iOS rejects programmatic play() without firing an "error" event
    ;; (always in Low Power Mode). Deliver false instead of blocking
    ;; the caller forever:
    (when-let [play-promise (.play video)]
      (.catch play-promise
              (fn [_e]
                (deliver! false))))
    ;; last resort, if neither "timeupdate" nor "error" fires and
    ;; play() stays pending:
    (js/setTimeout (fn []
                     (deliver! false))
                   8000)
    chan))
